import el from '@finn-no/create-element';

// Note: this class now uses both Spaden and Troika classes in a transitioning period.

export default function setupLightbox(ele) {
    if (
        el('div', {
            style: 'display: -webkit-flex; display: -ms-flex; display: flex;',
        }).style.display === ''
    ) {
        // Flexbox not supported, no lightbox for you
        return;
    }

    ele.addEventListener('click', handleOpenLightboxClick);

    let lightbox;
    let thumbsContainer;
    let imageContainer;
    let contentEle;
    let captionEle;
    let counterEle;
    let infoEle;
    let closeButton;
    let showThumbsButton;
    let showLargeImageButton;
    let focusTrap;
    let navButtonsEle;
    let imageWrapper;
    let thumbsWrapper;
    let currentImageIndex = 0;
    let openerElement;
    const isProbablyTouchDevice = /mobi|tablet/i.test(navigator.userAgent); // this will do for now
    const imageList = getImageList(ele.getAttribute('data-gallerylightbox-name'));
    let thumbsVisible = imageList.length !== 1;

    function handleOpenLightboxClick(e) {
        if (e.button !== 0 || e.metaKey || e.shiftKey || e.ctrlKey || e.altKey) {
            return;
        }

        if (e.target.closest('[data-next]') || e.target.closest('[data-prev]')) {
            return;
        }

        e.preventDefault();
        openerElement = document.activeElement;
        let startIndex = 0;
        const element = e.target.closest('[data-index]');
        if (element) {
            startIndex = Number(element.getAttribute('data-index'));
        }
        setupLightBox(startIndex);
    }

    function handleThumbClick(e) {
        e.preventDefault();
        hideThumbs();
        showMedia(Number(e.target.getAttribute('data-index')));
        lightbox.focus();
    }

    function handleCloseClick() {
        removeLightbox();
    }

    function handleToggleClick() {
        toggleThumbs();
    }

    function handleNextClick(event) {
        event.stopPropagation();
        showNextImage();
    }

    function handlePrevClick(event) {
        event.stopPropagation();
        showPrevImage();
    }

    function handleLightboxClick(e) {
        if (e.pageX > getDocumentWidth() / 2) {
            showNextImage();
        } else {
            showPrevImage();
        }
    }

    function handleKeyDown(e) {
        if (e.metaKey || e.altKey || e.shiftKey || e.ctrlKey) {
            return;
        }
        switch (e.keyCode) {
            case 32: // Space
                if (thumbsVisible) {
                    hideThumbs();
                    showMedia(Number(e.target.getAttribute('data-index')));
                } else {
                    showThumbs();
                }
                break;

            case 27: // Esc
                removeLightbox();
                break;

            case 39: // Right arrow
                if (thumbsVisible) {
                    focusNextThumb();
                } else {
                    showNextImage();
                }
                break;

            case 37: // Left arrow
                if (thumbsVisible) {
                    focusPrevThumb();
                } else {
                    showPrevImage();
                }
                break;

            default:
                return;
        }

        e.stopPropagation();
        e.preventDefault();
    }

    function showNextImage() {
        showMedia((currentImageIndex + 1) % imageList.length);
    }

    function showPrevImage() {
        let index = (currentImageIndex - 1) % imageList.length;
        if (index < 0) {
            index += imageList.length;
        }
        showMedia(index);
    }

    function focusNextThumb() {
        if (document.activeElement.nextSibling) {
            document.activeElement.nextSibling.focus();
        } else {
            document.activeElement.parentNode.firstElementChild.focus();
        }
    }

    function focusPrevThumb() {
        if (document.activeElement.previousSibling) {
            document.activeElement.previousSibling.focus();
        } else {
            document.activeElement.parentNode.lastElementChild.focus();
        }
    }

    function showMedia(index) {
        const media = imageList[index];
        if (media.videoSrc) {
            showVideo(media, index);
        } else {
            showImage(media, index);
        }
    }

    function showVideo(video, index) {
        let videoType;
        if (video.videoSrc.indexOf('youtube') !== -1) {
            videoType = 'YT';
        }
        if (video.videoSrc.indexOf('vimeo') !== -1) {
            videoType = 'VI';
        }
        video.videoSrc = ele.querySelector('iframe').getAttribute('src');

        const videoId = video.videoSrc.split('/').pop();
        const swipeLayer = el('div.gallery-swipe-layer', {
            'data-video-swipe': '',
        });
        const videoEle = el(
            'div.centered-image.gallery-full-size',
            null,
            isProbablyTouchDevice ? swipeLayer : null,
            el('meta', {
                name: 'WA.VIDEO',
                content: 'yes',
            }),
            el('meta', {
                name: 'WA.VIDEO_ID',
                content: videoId,
            }),
            el('meta', {
                name: 'WA.VIDEO_TYPE',
                content: videoType,
            }),
            el(
                'div.media-container',
                null,
                el('iframe', {
                    width: '640',
                    height: '360',
                    src: video.videoSrc,
                    frameborder: 0,
                    allowfullscreen: '',
                }),
            ),
        );
        setVideoPreferences(video, videoEle, index, swipeLayer);
        preloadImages(index);
    }

    function setVideoPreferences(video, videoEle, index, swipeLayer) {
        imageWrapper.style.maxWidth = '1000px';
        imageWrapper.style.maxHeight = '667px';
        updateMedia(video, videoEle, index);
        if (swipeLayer) {
            swipeLayer.addEventListener('click', (e) => {
                e.stopPropagation();
                e.target.remove();
            });
        }
    }

    function showImage(img, index) {
        const element = el('img.lightbox-image-currentimage.lightbox__current-image', {
            srcset: img.srcset,
            src: img.src,
            alt: img.alt,
        });
        imageWrapper.style.maxWidth = img.width > 0 ? `${img.width}px` : '';
        imageWrapper.style.maxHeight = img.height > 0 ? `${img.height}px` : '';
        updateMedia(img, element, index);
        imageContainer.style.margin = '0';
        preloadImages(index);
    }

    function updateMedia(media, element, index) {
        captionEle.textContent = media.caption || '\u200B'; // Zero-width space to always reserve space
        counterEle.textContent = media.title || '';
        contentEle.replaceWith(element);
        contentEle = element;
        currentImageIndex = index;
    }

    // FIXME: this needs some serious refactoring
    function showThumbs() {
        imageContainer.classList.add('u-display-none', 'hidden');
        showLargeImageButton.classList.remove('u-display-none', 'hidden');
        showLargeImageButton.classList.add('lightbox__toggle-button');
        showThumbsButton.classList.add('u-display-none', 'hidden');
        showThumbsButton.classList.remove('lightbox__toggle-button');
        counterEle.classList.add('invisible');
        captionEle.classList.add('u-display-none', 'hidden');
        navButtonsEle.classList.add('u-display-none', 'hidden');
        thumbsWrapper.classList.remove('u-display-none', 'hidden');
        infoEle.classList.remove('u-display-none', 'hidden');
        thumbsContainer.querySelector(`[data-index='${currentImageIndex}']`).focus();
        lightbox.removeEventListener('touchmove', preventBackgroundScroll);
        thumbsVisible = true;
    }

    function hideThumbs() {
        showLargeImageButton.classList.add('u-display-none', 'hidden');
        showLargeImageButton.classList.remove('lightbox__toggle-button');
        showThumbsButton.classList.remove('u-display-none', 'hidden');
        showThumbsButton.classList.add('lightbox__toggle-button');
        thumbsWrapper.classList.add('u-display-none', 'hidden');
        infoEle.classList.add('u-display-none', 'hidden');
        imageContainer.classList.remove('u-display-none', 'hidden');
        counterEle.classList.remove('invisible');
        captionEle.classList.remove('u-display-none', 'hidden');
        navButtonsEle.classList.remove('u-display-none', 'hidden');
        // For some reason, when focusing this in Firefox, the click handler is invoked.
        // setTimeout avoids the issue
        window.setTimeout(() => {
            showThumbsButton.focus();
        }, 200);
        lightbox.addEventListener('touchmove', preventBackgroundScroll);
        thumbsVisible = false;
    }

    function toggleThumbs() {
        if (thumbsVisible) {
            hideThumbs();
        } else {
            showThumbs();
        }
    }

    function removeLightbox() {
        openerElement.focus();
        removeTempStyle();
        lightbox.remove();
        lightbox = null;
        imageContainer.removeEventListener('swipeleft', showPrevImage);
        imageContainer.removeEventListener('swiperight', showNextImage);
    }

    function createFocusLoops() {
        lightbox.addEventListener('focus', () => {
            if (showThumbsButton.classList.contains('hidden')) {
                showLargeImageButton.focus();
            } else {
                showThumbsButton.focus();
            }
        });
        contentEle.addEventListener('focus', () => {
            lightbox.focus();
        });
        focusTrap.addEventListener('focus', () => {
            lightbox.focus();
        });
    }

    function preventBackgroundScroll(e) {
        if (e.touches.length === 1) {
            e.preventDefault();
        }
    }

    function applyTempStyle() {
        document.documentElement.style.overflow = document.body.style.overflow = 'hidden';
        document.documentElement.style.position = document.body.style.position = 'relative';
        document.documentElement.style.height = document.body.style.height = '100%';
    }

    function removeTempStyle() {
        document.documentElement.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('position');
        document.documentElement.style.removeProperty('height');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('height');
    }

    function setupLightBox(startIndex) {
        currentImageIndex = startIndex;
        thumbsVisible = false;
        renderLightbox();
        applyTempStyle();

        if (thumbsVisible) {
            renderThumbs();
            showThumbs();
            showMedia(currentImageIndex);
        } else {
            showMedia(currentImageIndex);
            hideThumbs();
            renderThumbs();
        }

        imageContainer.addEventListener('swipeleft', showNextImage);
        imageContainer.addEventListener('swiperight', showPrevImage);
        lightbox.addEventListener('keydown', handleKeyDown);
        createFocusLoops();
    }

    function renderLightbox() {
        if (lightbox) {
            return;
        }

        counterEle = el('div.lightbox-imagecounter.u-milk.u-t4.lightbox__image-counter');
        thumbsContainer = el('div.lightbox-thumbs.u-pa2.lightbox__thumbs');
        thumbsWrapper = el('div.lightbox-thumbs-wrapper.lightbox__thumbs-wrapper', null, thumbsContainer);
        showThumbsButton = el(
            'button.lightbox-toggle.u-t4.milk.clickable.u-pv16.u-ph8.lightbox__toggle-button',
            {
                type: 'button',
                onclick: handleToggleClick,
                style: 'min-width: 170px; text-align: left;',
            },
            el(
                'svg:svg.valign-middle.u-valign-middle',
                { width: '18', height: '18', viewBox: '0 0 18 18' },
                el('svg:path', {
                    fill: '#fff',
                    d: 'M1 1h4v4H1zM7 1h4v4H7zM13 1h4v4h-4zM1 7h4v4H1zM7 ' + '7h4v4H7zM13 7h4v4h-4zM1 13h4v4H1zM7 13h4v4H7zM13 13h4v4h-4z',
                }),
            ),
            el('span.valign-middle.mls.u-valign-middle.u-ml4', null, 'Bildeoversikt'),
        );
        showLargeImageButton = el(
            'button.lightbox-toggle.u-t4.u-milk.clickable.u-pv16.u-ph8.lightbox__toggle-button',
            {
                type: 'button',
                onclick: handleToggleClick,
                style: 'min-width: 170px; text-align: left;',
            },
            el(
                'svg:svg.valign-middle.u-valign-middle',
                { width: '18', height: '18', viewBox: '0 0 18 18' },
                el('svg:path', {
                    fill: '#fff',
                    d: 'M1 1h16v16H1z',
                }),
            ),
            el('span.valign-middle.mls.u-valign-middle.u-ml4', null, 'Store bilder'),
        );
        closeButton = el(
            'button.lightbox-close.blank.u-t4.u-milk.clickable.u-pv16.u-ph8.lightbox__close-button.u-pa8',
            {
                type: 'button',
                onclick: handleCloseClick,
                'aria-label': 'Lukk',
                title: 'Lukk',
            },
            el(
                'svg:svg.valign-middle.u-valign-middle',
                { width: '18', height: '18', viewBox: '0 0 18 18' },
                el('svg:path', {
                    stroke: '#fff',
                    'stroke-width': '3',
                    d: 'M2 2l14 14M16 2L2 16',
                }),
            ),
        );
        captionEle = el('p.u-text-center.milk.u-t4.lightbox__caption', {
            'aria-live': 'polite',
        });
        contentEle = el('img.lightbox-image-currentimage.lightbox__current-image');
        imageWrapper = el('div.lightbox-image-wrapper.lightbox-image__wrapper', null, contentEle);
        imageContainer = el('div.lightbox-body.clickable.man.noselect.lightbox__body', { onclick: handleLightboxClick }, imageWrapper);
        focusTrap = el('div.lightbox-focustrap', { tabindex: 0 });
        navButtonsEle = el(
            'div',
            null,
            el(
                'button.blank.lightbox-right.image-carousel__button-right',
                {
                    type: 'button',
                    onclick: handleNextClick,
                    'aria-label': 'Neste bilde',
                },
                el(
                    'svg:svg.lightbox-arrow-icon.image-carousel__button-arrow',
                    { viewBox: '0 0 12 22', width: '20', height: '22' },
                    el('svg:path', {
                        fill: 'none',
                        stroke: '#fff',
                        'stroke-width': '2',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        d: 'M2 2l8 9-8 9',
                    }),
                ),
            ),
            el(
                'button.blank.lightbox-left.image-carousel__button-left',
                {
                    type: 'button',
                    onclick: handlePrevClick,
                    'aria-label': 'Forrige bilde',
                },
                el(
                    'svg:svg.blockify.lightbox-arrow-icon.image-carousel__button-arrow',
                    { viewBox: '0 0 12 22', width: '20', height: '22' },
                    el('svg:path', {
                        fill: 'none',
                        stroke: '#fff',
                        'stroke-width': '2',
                        'stroke-linecap': 'round',
                        'stroke-linejoin': 'round',
                        d: 'M10 2l-8 9 8 9',
                    }),
                ),
            ),
        );
        infoEle = el(
            'u-p.u-t4.centerify.u-milk.lightbox__caption',
            null,
            'Trykk ',
            el('kbd', null, 'Space'),
            ' for å veksle mellom oversikt og store bilder, ',
            el('kbd', { 'aria-label': 'Pil venstre' }, '←'),
            ' ',
            el('kbd', { 'aria-label': 'Pil høyre' }, '→'),
            ' for å bla, og ',
            el('kbd', null, 'Esc'),
            ' for å lukke',
        );

        // biome-ignore lint/style/noParameterAssign: This existed before the lint rule was added
        ele = el(
            'div.lightbox',
            { tabindex: 0, role: 'dialog', 'aria-modal': 'true', style: 'z-index:20' },
            el(
                'div.lightbox-content.lightbox__content',
                null,
                el(
                    'div.lightbox-header.lightbox__header',
                    null,
                    counterEle,
                    el(
                        'div.lightbox-buttons.u-pr8.inlineblockify.lightbox__buttons',
                        null,
                        showLargeImageButton,
                        showThumbsButton,
                        closeButton,
                    ),
                ),
                imageContainer,
                captionEle,
                imageList.length > 1 ? navButtonsEle : null,
                thumbsWrapper,
                isProbablyTouchDevice ? null : infoEle,
                focusTrap,
            ),
        );
        for (const element of document.getElementsByClassName('lightbox')) {
            element.parentElement.removeChild(element);
        }

        lightbox = document.body.appendChild(ele);
    }

    function renderThumbs() {
        calculateThumbSizes();
        imageList.forEach((image, index) => {
            thumbsContainer.appendChild(
                el(
                    'a.lightbox-thumbs-image.lightbox__thumb-link',
                    {
                        href: image.src,
                        'data-index': index,
                        onclick: handleThumbClick,
                    },
                    el('img.clickable.blockify.lightbox__thumb$.u-bg-milk', {
                        'data-index': index,
                        src: image.thumbSrc || image.src,
                        height: image.thumbHeight,
                        width: image.thumbWidth || null, // if width is missing, don't set the attribute
                        alt: image.alt,
                    }),
                ),
            );
        });
    }

    function getDocumentWidth() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    function getDocumentHeight() {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    function calculateThumbHeight() {
        const defaultThumbHeight = 150;
        const maxHeight = 155;
        const minHeight = 60;
        const imageMargin = 20;
        // Multiplying with 0.7 is ultimate caveman way to compensate for uneven line breaks and the top bar.
        const availableArea = getDocumentWidth() * getDocumentHeight() * 0.7;

        const thumbWidths = imageList.map((image) => {
            if (!image.width || !image.height) {
                return Math.ceil(defaultThumbHeight * 1.333);
            }
            const ratio = image.width / image.height;
            const thumbWidth = defaultThumbHeight * ratio + imageMargin;
            return Math.ceil(thumbWidth);
        });

        const thumbArea = thumbWidths.reduce((prev, current) => prev + current * (defaultThumbHeight + imageMargin));

        const fillRatio = thumbArea / availableArea;
        const thumbHeight = Math.ceil(defaultThumbHeight / Math.sqrt(fillRatio));
        return Math.min(Math.max(thumbHeight, minHeight), maxHeight);
    }

    function calculateThumbSizes() {
        const height = calculateThumbHeight();
        let ratio = 1.33;
        imageList.forEach((img) => {
            if (img.height && img.width) {
                ratio = img.width / img.height;
            }
            if (img.width) {
                img.thumbWidth = Math.ceil(height * ratio);
            }
            img.thumbHeight = height;
        });
    }

    function preloadImages(index) {
        const PRELOAD_COUNT = 5; // will preload next and previous
        const preloadIndexes = [];
        const imageListLength = imageList.length;
        const imageListLastIndex = imageListLength - 1;

        const startIndex = keepInRange(index - PRELOAD_COUNT);
        const endIndex = keepInRange(index + PRELOAD_COUNT);

        addToPreloadIndexes(startIndex, endIndex);

        if (startIndex === 0) {
            // add from end of imageList
            const _start = keepInRange(index - PRELOAD_COUNT + imageListLength);
            addToPreloadIndexes(_start, imageListLastIndex);
        }

        if (endIndex === imageListLastIndex) {
            // add from beginning of imageList
            const _end = keepInRange(index + PRELOAD_COUNT - imageListLength);
            addToPreloadIndexes(0, _end);
        }

        preloadIndexes.splice(preloadIndexes.indexOf(index), 1); // remove current index
        preloadIndexes.forEach((i) => {
            preloadImage(imageList[i]);
        });

        function addToPreloadIndexes(from, to) {
            while (from <= to) {
                if (preloadIndexes.indexOf(from) === -1) {
                    // biome-ignore lint/style/noParameterAssign: This existed before the lint rule was added
                    preloadIndexes.push(from++);
                } else {
                    // biome-ignore lint/style/noParameterAssign: This existed before the lint rule was added
                    from++;
                }
            }
        }

        function keepInRange(i) {
            return Math.min(Math.max(i, 0), imageListLastIndex);
        }
    }

    function preloadImage(img) {
        // Note that the order is important here. `src` cannot be set before `srcset`,
        // otherwise we might end up loading two images.
        if (img.srcset) {
            el('img', { srcset: img.srcset, src: img.src });
        } else {
            el('img', { src: img.src });
        }
    }

    function getImageList(name) {
        const imageEles = document.querySelectorAll(`img[data-gallerylightbox-name=${name}], svg[data-gallerylightbox-name=${name}]`);
        return Array.from(imageEles).map((img, index, arr) => ({
            src: img.getAttribute('data-src'),
            thumbSrc: img.getAttribute('data-thumb-src'),
            srcset: img.getAttribute('data-srcset'),
            alt: img.getAttribute('alt'),
            height: img.height,
            width: img.width,
            title: `${index + 1} av ${arr.length}`,
        }));
    }
}
